<template>
    <div class="report">
        <div class="avatar">
            <div class="contianer dfx">
                <el-button class="go_back" @click="goBack">
                <img src="../assets/previous.svg" alt="返回上一级" />
                </el-button>
                <div class="column">{{ column }}</div>
            </div>
        </div>
        <div class="asstes contianer">
          <div ref="form" :model="form" @click="goUserDetail(item.id)" class="item"  v-for="item in combinedArray" :key="item.id">
            <div class="vatar">
              <el-avatar icon="el-icon-user-solid" :size="size" :src="item.avatar"></el-avatar>
            </div>
            <div class="con">
              <div class="text">
                  <div class="name"><span>姓名：</span>{{item.nickname}}</div>
                  <div class="num"><span>年龄：</span>{{item.age}}</div>
              </div>
              <div class="age">
                <div class="sex"><span>性别：</span>{{item.sex}}</div>
                <el-button type="primary">
                  <router-link v-if="item.status === 5" to="/table">
                    <span>等待测评</span>
                  </router-link>
                  <router-link v-else-if="item.status === 8" :to="'/evalua?selected=' + item.id + '&nameStr=' + item.nickname">
                    <span>等待报告</span>
                  </router-link>
                  <router-link v-else-if="item.status === 11" :to="'/evaluahistory?student_id=' + item.id + '&name=' + item.nickname">
                    <span>查看历史报告</span>
                  </router-link>
                  <router-link v-else-if="item.status === 0" to="/track">
                    <span>跟进中</span>
                  </router-link>
                </el-button>
              </div>
            </div>
          </div>
          <div class="item" v-if="loading || noMoreData" style="background: #f9dcdc;">
            <div v-if="loading" style="text-align: center;margin: 0 auto;">加载中...</div>
            <div v-if="noMoreData" style="text-align: center;margin: 0 auto;">没有更多数据！</div>
          </div>
        </div>
    </div>
</template>
<script>
import { getUserList } from '@/api/app'
import { Loading } from 'element-ui'
export default {
  name: 'Mystudents',
  data () {
    return {
      column: '我的学员',
      activeName: 'first',
      size: 'large',
      page_no: 1,
      loading: false,
      noMoreData: false,
      items: [],
      fDatas: {},
      form: {}/* ,
      form: {
        inform1: [
          { user: require('@/assets/user_avatar01.png'), byname: '乐乐', sex: '男', age: '5岁10月', status: 0 },
        ],
        inform2: [
          { user: require('@/assets/user_avatar05.png'), byname: '小当归', sex: '男', age: '5岁10月', status: 1 },
        ],
        inform3: [
          { user: require('@/assets/user_avatar03.png'), byname: '人参', sex: '男', age: '5岁10月', status: 2 },
        ]
      } */
    }
  },
  computed: {
    // 计算属性，用于合并数组
    /* combinedArray () {
      return [...this.form.inform1, ...this.form.inform2, ...this.form.inform3]
    } */
    combinedArray () {
      return [...this.items]
    }
  },
  created () {
    // 在组件创建时根据查询参数切换选项卡
    const tab = this.$route.query.tab
    if (tab) {
      this.activeName = tab
    }
    this.setDataInit()
  },
  mounted () {
    this.setDataInit()
    this.fetchData()
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    setDataInit () {
      this.page_no = 1
      this.items = []
      this.fDatas = {}
      this.noMoreData = false
    },
    goUserDetail (id) {
      this.$router.push('/addstudy?id=' + id)
    },
    async fetchData () {
      if (this.fDatas.count) {
        if (this.fDatas.count === this.items.length || this.fDatas.count < this.fDatas.page_size) {
          // this.loading = false
          this.noMoreData = true
          /* this.$message({
            message: '没有更多数据了',
            type: 'warning'
          }) */
          return
        }
      }
      // 显示加载层
      this.loadingInstance = Loading.service({ fullscreen: true })
      this.fDatas = await getUserList({page_no: this.page_no, page_size: 30})
      this.loadingInstance && this.loadingInstance.close()
      const newItems = this.fDatas.lists.map(item => {
        // 创建一个新的对象，避免直接修改原数组
        const newItem = { ...item }
        // console.log(newItem)
        // 根据 sex 的值来修改显示
        if (newItem.sex * 1 === 1) {
          newItem.sex = '男'
        } else if (newItem.sex * 1 === 2) {
          newItem.sex = '女'
        }
        return newItem
      })
      // console.log(newItems)
      if (newItems.length === 0) {
        this.noMoreData = true
      } else {
        this.items = [...this.items, ...newItems]
        this.page_no++
      }
    },
    handleScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // console.log('===scrollTop====:', scrollTop)
      const windowHeight = window.innerHeight
      // console.log('===windowHeight====:', windowHeight)
      const documentHeight = document.documentElement.scrollHeight
      // console.log('===documentHeight====:', documentHeight)
      if (windowHeight === documentHeight) {
        return
      }
      if (scrollTop + windowHeight >= documentHeight - 10 && windowHeight !== documentHeight) {
        // console.log('===handleScroll====:')
        if (!this.noMoreData) {
          this.fetchData()
        }
      }
    }
  },
  watch: {
    '$route.query.tab' (newTab) {
      if (newTab) {
        this.activeName = newTab
      }
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/Mystudents.vue